module.exports = __webpack_public_path__ + "img/SE powered by FVC narrow - dark.50f3698a.png";